import {
  CalendarClock, CalendarCheck, CalendarX, ArrowLeftRight,
  FileUp, FileCheck, FileX, FileText,
  CalendarDays, Banknote, TrendingUp, TrendingDown, DollarSign,
  Lock, LogOut, UserPlus, UserCheck, UserX, UserCog,
  AlertCircle, RefreshCw, MessageCircle, ClipboardList,
  Target, Flag, Star, CalendarPlus,
  Bell, type LucideIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";

interface IconDef {
  icon: LucideIcon;
  bg: string;
  fg: string;
}

const TYPE_MAP: Record<string, IconDef> = {
  // Leave
  leave_submitted:         { icon: CalendarClock,  bg: "bg-blue-100 dark:bg-blue-900/30",   fg: "text-blue-600 dark:text-blue-400" },
  leave_approved:          { icon: CalendarCheck,  bg: "bg-green-100 dark:bg-green-900/30", fg: "text-green-600 dark:text-green-400" },
  leave_rejected:          { icon: CalendarX,      bg: "bg-red-100 dark:bg-red-900/30",     fg: "text-red-600 dark:text-red-400" },
  leave_replacement:       { icon: ArrowLeftRight, bg: "bg-sky-100 dark:bg-sky-900/30",     fg: "text-sky-600 dark:text-sky-400" },
  leave_cancelled:         { icon: CalendarX,      bg: "bg-gray-100 dark:bg-gray-800",      fg: "text-gray-500 dark:text-gray-400" },
  leave_created_on_behalf: { icon: CalendarPlus,   bg: "bg-teal-100 dark:bg-teal-900/30",   fg: "text-teal-600 dark:text-teal-400" },
  leave_document_uploaded: { icon: FileUp,         bg: "bg-blue-100 dark:bg-blue-900/30",   fg: "text-blue-600 dark:text-blue-400" },
  // Documents
  document_uploaded:       { icon: FileUp,         bg: "bg-blue-100 dark:bg-blue-900/30",   fg: "text-blue-600 dark:text-blue-400" },
  document_completed:      { icon: FileCheck,      bg: "bg-green-100 dark:bg-green-900/30", fg: "text-green-600 dark:text-green-400" },
  document_rejected:       { icon: FileX,          bg: "bg-red-100 dark:bg-red-900/30",     fg: "text-red-600 dark:text-red-400" },
  document_request:        { icon: FileText,       bg: "bg-violet-100 dark:bg-violet-900/30", fg: "text-violet-600 dark:text-violet-400" },
  // Calendar
  event_new:               { icon: CalendarDays,   bg: "bg-purple-100 dark:bg-purple-900/30", fg: "text-purple-600 dark:text-purple-400" },
  // Salary / Payroll
  salary_processed:        { icon: Banknote,       bg: "bg-emerald-100 dark:bg-emerald-900/30", fg: "text-emerald-600 dark:text-emerald-400" },
  salary_increase_approved:{ icon: TrendingUp,     bg: "bg-green-100 dark:bg-green-900/30", fg: "text-green-600 dark:text-green-400" },
  salary_increase_rejected:{ icon: TrendingDown,   bg: "bg-red-100 dark:bg-red-900/30",     fg: "text-red-600 dark:text-red-400" },
  salary_increase_requested:{ icon: DollarSign,    bg: "bg-amber-100 dark:bg-amber-900/30", fg: "text-amber-600 dark:text-amber-400" },
  // Compliance
  gdpr_retention:          { icon: Lock,           bg: "bg-gray-100 dark:bg-gray-800",      fg: "text-gray-500 dark:text-gray-400" },
  // Offboarding
  offboarding_request:     { icon: LogOut,         bg: "bg-orange-100 dark:bg-orange-900/30", fg: "text-orange-600 dark:text-orange-400" },
  // Teams
  team_join_request:       { icon: UserPlus,       bg: "bg-blue-100 dark:bg-blue-900/30",   fg: "text-blue-600 dark:text-blue-400" },
  team_request_approved:   { icon: UserCheck,      bg: "bg-green-100 dark:bg-green-900/30", fg: "text-green-600 dark:text-green-400" },
  team_request_rejected:   { icon: UserX,          bg: "bg-red-100 dark:bg-red-900/30",     fg: "text-red-600 dark:text-red-400" },
  // Concerns
  concern_new:             { icon: AlertCircle,    bg: "bg-amber-100 dark:bg-amber-900/30", fg: "text-amber-600 dark:text-amber-400" },
  concern_status_changed:  { icon: RefreshCw,      bg: "bg-sky-100 dark:bg-sky-900/30",     fg: "text-sky-600 dark:text-sky-400" },
  concern_assigned:        { icon: UserCog,        bg: "bg-violet-100 dark:bg-violet-900/30", fg: "text-violet-600 dark:text-violet-400" },
  concern_feedback:        { icon: MessageCircle,  bg: "bg-blue-100 dark:bg-blue-900/30",   fg: "text-blue-600 dark:text-blue-400" },
  // Workflows / Tasks
  workflow_task:           { icon: ClipboardList,  bg: "bg-indigo-100 dark:bg-indigo-900/30", fg: "text-indigo-600 dark:text-indigo-400" },
  recruitment_application_received: { icon: UserPlus, bg: "bg-cyan-100 dark:bg-cyan-900/30", fg: "text-cyan-600 dark:text-cyan-400" },
  onboarding_started:     { icon: UserCheck,      bg: "bg-blue-100 dark:bg-blue-900/30",   fg: "text-blue-600 dark:text-blue-400" },
  // Performance
  performance_kpi_added:   { icon: Target,        bg: "bg-violet-100 dark:bg-violet-900/30", fg: "text-violet-600 dark:text-violet-400" },
  performance_goal_added:  { icon: Flag,          bg: "bg-blue-100 dark:bg-blue-900/30",    fg: "text-blue-600 dark:text-blue-400" },
  performance_review_added:{ icon: Star,          bg: "bg-amber-100 dark:bg-amber-900/30",  fg: "text-amber-600 dark:text-amber-400" },
  // Meeting requests
  meeting_requested:       { icon: CalendarPlus,  bg: "bg-amber-100 dark:bg-amber-900/30",  fg: "text-amber-600 dark:text-amber-400" },
  meeting_accepted:        { icon: CalendarCheck, bg: "bg-green-100 dark:bg-green-900/30",  fg: "text-green-600 dark:text-green-400" },
  meeting_declined:        { icon: CalendarX,     bg: "bg-red-100 dark:bg-red-900/30",      fg: "text-red-600 dark:text-red-400" },
};

const DEFAULT_DEF: IconDef = {
  icon: Bell,
  bg: "bg-gray-100 dark:bg-gray-800",
  fg: "text-gray-500 dark:text-gray-400",
};

interface NotificationIconProps {
  type: string;
  /** "sm" = 8×8 container (bell popover), "md" = 10×10 container (full page) */
  size?: "sm" | "md";
  dimmed?: boolean;
}

export function NotificationIcon({ type, size = "md", dimmed = false }: NotificationIconProps) {
  const def = TYPE_MAP[type] ?? DEFAULT_DEF;
  const Icon = def.icon;
  const containerCls = size === "sm" ? "h-8 w-8" : "h-10 w-10";
  const iconCls = size === "sm" ? "h-4 w-4" : "h-5 w-5";

  return (
    <div
      className={cn(
        containerCls,
        "shrink-0 rounded-full flex items-center justify-center",
        def.bg,
        dimmed && "opacity-60",
      )}
    >
      <Icon className={cn(iconCls, def.fg)} strokeWidth={1.75} />
    </div>
  );
}
